import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorMessage from "components/reusable/ErrorMessage";
import Toolbar from "components/Toolbar";
import useToastContext from "hooks/useToastContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react18-input-otp";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function RegisterOtp() {
  const { t } = useTranslation();
  const location = useLocation();
  const notification = useToastContext();
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(59);
  const [minutes, setMinutes] = useState(0);
  const [loading, setLoading] = useState(false);

  let timerRef;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    timerRef = setInterval(() => {
      if (minutes >= 0) {
        if (seconds === 0) {
          if (minutes > 0) {
            setSeconds(60);
            setMinutes((prev) => prev - 1);
          } else {
            setSeconds(0);
          }
        } else {
          setSeconds((prev) => prev - 1);
        }
      } else {
        clearInterval(timerRef);
      }
    }, 1000);
    return () => clearInterval(timerRef);
  });

  const [errors] = useState({});
  const [otp, setOtp] = useState({
    otp_phone: null,
    otp_email: null,
  });

  const [isEmailFocused, setIsEmailFocused] = useState(false);
  useEffect(() => {
    if (otp?.otp_phone?.length === 4 && isEmailFocused === false) {
      const emailOtpElement = document.getElementById("emailOtpInput-0");
      emailOtpElement?.focus();
      setIsEmailFocused(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  const validation = () => {
    if (otp.otp_phone && otp.otp_email) {
      return true;
    } else if (!otp.otp_phone && otp.otp_email) {
      notification.error("Please, enter phone otp");
      return false;
    } else if (otp.otp_phone && !otp.otp_email) {
      notification.error("Please, enter email otp");
      return false;
    } else {
      notification.error("Please, enter phone and email otp");
      return false;
    }
  };

  const handleSubmit = async () => {
    const isValid = validation();
    if (!isValid) {
      return;
    }
    if (minutes === 0 && seconds === 0) {
      notification.error("Otp has expired.");
      return;
    }
    if (!otp.otp_phone || !otp.otp_email) {
      notification.error("Please enter all OTP.");
      return;
    }

    setLoading(true);
    let res;
    try {
      let sendData = {};
      sendData.otp_phone = otp.otp_phone;
      sendData.otp_email = otp.otp_email;
      sendData.country_code = "355";
      sendData.username = location?.state?.username;
      sendData.mobile = location?.state?.phone;
      sendData.email = location?.state?.email;

      res = await apiPost(pathObj.verifyOtp, sendData);
      if (res.data.success) {
        notification.success(res.data.message);
        navigate("/login", { replace: true });
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      notification.error(res?.data?.message);
    }

    setLoading(false);
  };

  const handleChange = (value, name) => setOtp({ ...otp, [name]: value });

  const handleResendOtp = async () => {
    setLoading(true)
    try {
      if (minutes === 0 && seconds === 0) {
        let sendData = {};
        sendData.country_code = "355";
        sendData.mobile = location?.state?.phone;
        sendData.email = location?.state?.email;
        const res = await apiPost(pathObj.resendOtp, sendData);
        if (res.data.success === true) {
          notification.success(res.data.message);
          setSeconds(59);
          setMinutes(0);
        } else {
          notification.error(res.data.message);
        }
      } else {
        notification.error(t("WAIT_FOR_OTP"));
      }
    } catch (err) {
    }
    setLoading(false)
  };

  return (
    <>
      <Toolbar title={t("OTP")} showBackBtn={true} />
      <div className="flex w-full items-center justify-center">
        <div className="mt-5 w-full md:w-[20rem] flex flex-col items-center">
          <div className="sm:w-full">
            {(seconds > 0 || minutes > 0) && (
              <div className="mb-4 d-flex justify-content-between mt-4">
                <div className="font-medium">
                  {t("OTP_EXPIRING")} {minutes}:{seconds}
                </div>
              </div>
            )}
            <ErrorMessage message={errors?.otp_email?.message} />
          </div>

          <div className="mb-4">
            <span className="font-medium">{t("PHONE_OTP")}</span>

            <OtpInput
              inputStyle={{
                border: "1.5px solid var(--card-color)",
                width: "5rem",
                background: "transparent",
                height: "2.4rem",
                color: "var(--text-color)",
                fontWeight: "bold",
                marginRight: ".5rem",
                outline: "none",
                borderRadius: "8px",
              }}
              shouldAutoFocus
              isInputNum={true}
              value={otp.otp_phone}
              containerStyle="text-center mt-2"
              onChange={(value) => handleChange(value, "otp_phone")}
              numInputs={4}
              separator={<span> </span>}
            />

            <ErrorMessage message={errors?.otp_phone?.message} />
          </div>

          <div className="mb-4">
            <span className="font-medium">{t("EMAIL_OTP")}</span>

            <OtpInput
              inputStyle={{
                border: "1.5px solid var(--card-color)",
                width: "5rem",
                background: "transparent",
                height: "2.4rem",
                color: "var(--text-color)",
                fontWeight: "bold",
                marginRight: ".5rem",
                outline: "none",
                borderRadius: "8px",
              }}
              shouldAutoFocus
              isInputNum={true}
              value={otp.otp_email}
              containerStyle="text-center mt-2"
              onChange={(value) => handleChange(value, "otp_email")}
              numInputs={4}
              separator={<span> </span>}
            />

            <ErrorMessage message={errors?.otp_email?.message} />
          </div>

          <div className="w-full mt-5">
            {loading ? (
              <div className="btn btn_theme w-full flex items-center justify-center p-3">
                <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
              </div>
            ) : (
              <button type="submit" className="btn btn_theme w-full py-3 mb-3 text-white" onClick={handleSubmit}>
                {t("O_VERIFY")}
              </button>
            )}
          </div>
          <div className="flex gap-1 text-center w-100 mb-2 mt-4">
            <span className="fw-bold">{t("DIDNT_RECEIVE_OTP?")}</span>
            <div onClick={handleResendOtp} className="link text-primary font-medium" style={{ cursor: "pointer" }}>
              {" "}
              {t("RESEND_OTP")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterOtp;
